// Fall back to non-Storybook when the build-time environment flag cannot be read.
export const isStorybook = () => {
  try {
    return process.env.STORYBOOK === 'true';
  } catch {
    return false;
  }
};
